import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ImageCropperModule } from 'ngx-image-cropper';
import { SocialLoginRegistrationComponent } from 'src/app/shared/components/social-login-registration/social-login-registration.component';
import { MaterialModule } from '../material/material.module';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { EditImageComponent } from './components/edit-image/edit-image.component';
import { Error404Component } from './components/error-404/error-404.component';
import { FormFieldErrorComponent } from './components/form-field-error/form-field-error.component';
import { InfoComponentComponent } from './components/info-component/info-component.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { PaymentPasswordConfirmationComponent } from './components/payment-password-confirmation/payment-password-confirmation.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { LocalizedDatePipe } from './pipes/localized-date/localized-date.pipe';
import { createTranslateLoader } from './utils/translate-utils';
import { CreditCardComponent } from './components/credit-card/credit-card.component';
import { TermsComponentComponent } from './components/terms-component/terms-component.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { UnderConstructionComponent } from './components/under-construction/under-construction.component';
import { SecureImagePipe } from './pipes/secure-image/secure-image.pipe';

@NgModule({
  declarations: [
    SpinnerComponent,
    Error404Component,
    FormFieldErrorComponent,
    SocialLoginRegistrationComponent,
    LocalizedDatePipe,
    ConfirmationDialogComponent,
    EditImageComponent,
    LineChartComponent,
    InfoComponentComponent,
    PaymentPasswordConfirmationComponent,
    CreditCardComponent,
    TermsComponentComponent,
    UnderConstructionComponent,
    SecureImagePipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ImageCropperModule,
    ChartsModule,
    PdfViewerModule,
    TranslateModule.forChild({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    })
  ],
  providers: [LocalizedDatePipe],
  exports: [
    TranslateModule,
    MaterialModule,
    FlexLayoutModule,
    FormFieldErrorComponent,
    FormsModule,
    ReactiveFormsModule,
    SpinnerComponent,
    Error404Component,
    SocialLoginRegistrationComponent,
    LocalizedDatePipe,
    ConfirmationDialogComponent,
    EditImageComponent,
    ImageCropperModule,
    ChartsModule,
    LineChartComponent,
    CreditCardComponent,
    UnderConstructionComponent,
    SecureImagePipe
  ]
})
export class SharedModule {}
